import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemList } from 'src/app/_common/constant/item-list';
import { AddressComponent } from '../address-component';
import { CanadaAddressValidation } from './canada-address.validator';
import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { Confirm, Country } from 'src/refresh/service/constant';
import { Address, InputData } from 'src/app/_common/data/input-data';

@Component({
     selector: 'canada-address',
     templateUrl: './canada-address.component.html',
     styleUrls: ['./canada-address.component.less']
})
export class CanadaAddressComponent extends AddressComponent implements OnInit {

     public error_needSpecialDelivery: string = "";
     public error_selectDeliveryMode: string = "";
     public error_deliverAddress_RR: string = "";
     public error_deliverAddress_MR: string = "";
     public error_deliverAddress_GD: string = "";
     public error_deliverAddress_POBox: string = "";
     public notEditable:boolean = false;

     constructor(public items: ItemList, private data:InputData,public viewportScroller: ViewportScroller) {
          super();

          this.idPrefix = this.getPrefix(); //should be unique for every component created
          this.streetNumberID = this.idPrefix + 'strNumber';
          this.streetNameID = this.idPrefix + 'strName';
          this.unitID = this.idPrefix + 'unit';
          this.buzzID = this.idPrefix + 'buzz';
          this.cityID = this.idPrefix + 'city';
          this.provinceID = this.idPrefix + 'prov';
          this.deliveryModeID = this.idPrefix + 'deliMode';
          this.needSpecialDeliveryID = this.idPrefix + 'needSD';

          this.notEditable = this.data.contact.notEditable;
          this.isCustodyOtherThanParent = this.data.eligibility.isCustodyOtherThanParent == Confirm.YES;
     }

     ngOnInit(): void {
          this.validator = new CanadaAddressValidation(this);
          if ( Util.isEmpty(this.addr.streetNumber) ) this.addr.streetNumber = "";
     }

     resetSpecialRoute(addr: Address){
          addr.deliveryMode = ''; 
          addr.deliveryAddr = '';
          this.error_needSpecialDelivery = '';
          this.error_selectDeliveryMode = '';
          this.error_deliverAddress_RR = '';
          this.error_deliverAddress_MR = '';
          this.error_deliverAddress_GD = '';
          this.error_deliverAddress_POBox  = '';
     }
}